<template>
<div>
  <div v-for="(data, i) in UCC_DETAILS" :key="i" class="border mx-1 p-2 mb-3 mt-2 baseContentFont">
    <b-row>
      <b-col md="9"><b>Original Filing Number: </b>{{ data.originalFilingNumber }}</b-col>
      <b-col><b>Original Filing Date: </b>{{ data.originalFilingDate }}</b-col>
    </b-row>
    <b-row>
      <b-col md="9"><b>Filing Jurisdiction: </b>{{ data.filingJurisdiction }}</b-col>
      <b-col><b>Original Filing Type: </b>{{ data.originalFilingType }}</b-col>
    </b-row>
    <div v-if="isListEmpty(data.uccFilingsModel).length">
      <div v-for="(item, ind) in isListEmpty(data.uccFilingsModel)" :key="ind">
      <BaseELabel :label="`Filings ${ item.filingDate ? '(' + item.filingDate + ')' : ''} - Record ${ind + 1}`"  class="my-2" new-style/>
      <div class="border p-1">
        <b-row>
          <b-col><b>Number: </b>{{ item.number }}</b-col>
          <b-col><b>Type: </b>{{ item.type }}</b-col>
          <b-col><b>Status: </b>{{ item.status }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Amount: </b>{{ item.amount }}</b-col>
          <b-col><b>Filing Number Indicator: </b>{{ item.filingNumberIndicator }}</b-col>
          <b-col><b>Contract Date: </b>{{ item.contractDate }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Contract Type: </b>{{ item.contractType }}</b-col>
          <b-col><b>Serial Number: </b>{{ item.serialNumber }}</b-col>
          <b-col><b>Vendor Entry Date: </b>{{ item.vendorEntryDate }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Vendor Update Date: </b>{{ item.vendorUpdateDate }}</b-col>
          <b-col><b>Microfilm Number: </b>{{ item.microFilmNumber }}</b-col>
          <b-col><b>Statement Filed: </b>{{ item.statementFiled }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Continuous Expiration: </b>{{ item.contExpiration }}</b-col>
        </b-row>
      </div>
    </div>
    </div>
    <div v-else>
      <BaseELabel label="Filings" class="my-2" new-style />
      <NoRecordFound v-if="!isListEmpty(data.uccFilingsModel).length"></NoRecordFound>
    </div>
    <div class="my-2">
      <BaseELabel :label="`Filing Offices (${isListEmpty(data.uccFilingOfficesModel).length})`" class="mb-2" new-style />
      <b-table
        :items="isListEmpty(data.uccFilingOfficesModel)"
        :fields="filingOffices"
        hover
        bordered
        responsive
        striped
        class="mb-0 fraudReportHeaderTable"
      >
      </b-table>
      <NoRecordFound v-if="!isListEmpty(data.uccFilingOfficesModel).length" ></NoRecordFound>
  </div>
  <!-- Tables start -->
  <div v-for="(dataItem, index) in isListEmpty(uccTables)" :key="index" class="my-2">
      <BaseELabel :label="`${dataItem} (${isListEmpty(data[uccTableItems[index]]).length})`" class="mb-2" new-style />
      <b-table
        :items="data[uccTableItems[index]]"
        :fields="uccFilings"
        hover
        bordered
        responsive
        striped
        class="mb-0 fraudReportHeaderTable"
        thead-tr-class="d-none"
      >
      <template v-slot:thead-top="">
        <b-tr>
          <b-th rowspan="1" :class="$style.debtorsFirstCol">Name</b-th>
          <b-th rowspan="2" :class="$style.debtorsSecondCol">Address</b-th>
          <b-th rowspan="1">SSN/FEIN</b-th>
        </b-tr>
        <b-tr>
          <b-th rowspan="1" :class="$style.debtorsFirstCol">Corporate State/Number/Type</b-th>
          <b-th rowspan="1">Foreign</b-th>
        </b-tr>
      </template>
      <template v-slot:cell(name)="rowitem">
        <div :class="`${rowitem.item.name ? 'mt-1 border-bottom' : 'mt-4 border-bottom'}`">{{ rowitem.item.name }}</div>
        <div :class="`${rowitem.item.corpNumberTypeState ? 'mt-1' : 'mt-4'}`">{{ rowitem.item.corpNumberTypeState }}</div>
      </template>
      <template v-slot:cell(address)="rowitem">
        <div :class="`${rowitem.item.address ? 'mt-3' : ''}`">{{ rowitem.item.address }}</div>
      </template>
      <template v-slot:cell(foreign)="rowitem">
        <div :class="`${rowitem.item.ssnFein ? 'mt-1 border-bottom' : 'mt-4 border-bottom'}`">{{ rowitem.item.ssnFein }}</div>
        <div :class="`${rowitem.item.foreign ? 'mt-1' : 'mt-4'}`">{{ rowitem.item.foreign }}</div>
      </template>
      </b-table>
      <NoRecordFound v-if="!isListEmpty(data[uccTableItems[index]]).length" ></NoRecordFound>
  </div>

  <!-- Tables end -->
  <div v-if="isListEmpty(data.uccCollateralsModel).length">
      <div v-for="(dt, j) in isListEmpty(data.uccCollateralsModel)" :key="j">
      <BaseELabel :label="`Collaterals - Record ${j + 1}`"  class="my-2" new-style />
      <div class="border p-1">
        <b-row>
          <b-col><b>Description: </b>{{ dt.desc }}</b-col>
          <b-col><b>Count: </b>{{ dt.count }}</b-col>
          <b-col><b>Property Description: </b>{{ dt.propDesc }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Address: </b>{{ dt.address }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Serial Number: </b>{{ dt.serialNumber }}</b-col>
          <b-col><b>Primary Machine: </b>{{ dt.primaryMachine }}</b-col>
          <b-col><b>Second Machine: </b>{{ dt.secondMachine }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Manufacturer Code: </b>{{ dt.manufactureCode }}</b-col>
          <b-col><b>Manufacturer: </b>{{ dt.manufacturer }}</b-col>
          <b-col><b>Manufactured Year: </b>{{ dt.manufactureYear }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Block: </b>{{ dt.block }}</b-col>
          <b-col><b>Lot: </b>{{ dt.lot }}</b-col>
          <b-col><b>New/Used: </b>{{ dt.newUsed }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Model Year: </b>{{ dt.modelYear }}</b-col>
          <b-col><b>Model: </b>{{ dt.model }}</b-col>
          <b-col><b>Model Description: </b>{{ dt.modelDesc }}</b-col>
        </b-row>
        <b-row>
          <b-col><b>Air Rights: </b>{{ dt.airRight }}</b-col>
          <b-col><b>Subterranean Rights: </b>{{ dt.subterraneanRight }}</b-col>
          <b-col><b>Easement: </b>{{ dt.easement }}</b-col>
        </b-row>
      </div>
    </div>
    </div>
    <div v-else>
      <BaseELabel label="Collaterals" class="my-2" new-style />
      <NoRecordFound v-if="!isListEmpty(data.uccCollateralsModel).length"></NoRecordFound>
    </div>
    <div class="my-2">
    <b-row class="my-1">
      <b-col><b>Signers {{ '(' + isListEmpty(data.uccSignersModel).length + ')' }} </b>
      </b-col>
    </b-row>
    <b-row v-if="isListEmpty(data.uccSignersModel).length" class="px-3">
      <b-col v-for="(x, ind) in isListEmpty(data.uccSignersModel)" :key="ind" md="6" class="border uccContainer">{{ x.name }}</b-col>
    </b-row>
    <NoRecordFound v-else></NoRecordFound>
    </div>
    <div class="my-2">
    <b-row class="my-1">
      <b-col><b>Comments:</b> {{ data.comments }}</b-col>
    </b-row>
    </div>
  </div>
  <NoRecordFound v-if="!UCC_DETAILS.length" class="mx-1"></NoRecordFound>
</div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    uccDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filingOffices: [
        {
          key: 'agency',
          label: 'Agency',
          thStyle: { width: '30%' }
        },
        {
          key: 'address',
          label: 'Address',
          thStyle: { width: '50%' }
        },
        {
          key: 'foreign',
          label: 'Foreign',
          thStyle: { width: '20%' }
        },
      ],
      uccFilings: [
        {
          key: 'name',
          label: '',
          thStyle: { width: '40%' }
        },
        {
          key: 'address',
          label: '',
        },
        {
          key: 'foreign',
          label: '',
        },
      ],
      uccTables: ['Debtors', 'Creditors', 'Secured', 'Assignees'],
      uccTableItems: ['uccDebtorsModel', 'uccCreditorsModel', 'uccSecuredModel', 'uccAssigneesModel'],
    }
  },
  computed: {
    UCC_DETAILS() {
      return this.uccDetails || []
    },
  },
  methods: {
    // formatSSN(value) {
    //   return value ? value.trim() ? 'XXX-XX-'+ value.substring(7) : '' : ''
    // },
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.debtorsFirstCol {
  width: 40%;
}
.debtorsSecondCol {
  width: 30%;
  vertical-align: middle !important;
}
</style>
<style scoped>
.uccContainer:nth-child(4n+3), .uccContainer:nth-child(4n+4){
    background: #eee;
}
</style>
